import React, { useContext, useEffect, useState } from "react";
import {
  ManageMastersLayout,
  SearchComponent,
  CsplTable as Table,
} from "../../../components";
import { manageMasterStore } from "../../../contexts";
import { getAdvisorRepresentativePlans } from "../../../services";
import { isEmpty, get } from "lodash";

const AdvisorRepresentativePlanContainer = (props) => {
  const { state, dispatch } = useContext(manageMasterStore);

  const [
    advisorRepresentativePlansFiltered,
    setAdvisorRepresentativePlansFiltered,
  ] = useState([]);
  const [advisorRepresentativePlans, setAdvisorRepresentativePlans] = useState(
    []
  );
  const advisorRepresentativeId = get(state, "advisorRepresentativeId", 0);
  useEffect(() => {
    if (advisorRepresentativeId) {
      getAdvisorRepresentativePlans(advisorRepresentativeId).then((res) => {
        if (res) {
          setAdvisorRepresentativePlansFiltered(
            get(res, "advisorAssociatedPlans", [])
          );
        }
      });
    }
  }, [advisorRepresentativeId]);
  useEffect(() => {
    setAdvisorRepresentativePlans(advisorRepresentativePlansFiltered);
  }, [advisorRepresentativePlansFiltered]);
  const onSearchChange = (val) => {
    setAdvisorRepresentativePlans(
      advisorRepresentativePlansFiltered?.filter(
        (e) => e.planName.includes(val) || e.rkPlanNumber.includes(val)
      )
    );
  };
  return (
    <ManageMastersLayout layoutHeader="Advisor Representative Plan Details">
      <div className="clearing-partner-account-plan-container">
        <SearchComponent
          placeholder="Search by plan name, number"
          className="search-component-clearing-partner"
          onSearchChange={onSearchChange}
        />
        <div className="header-label">
          <div className="clearing-partner-subjects">
            <div className="clearing-partner-recently-added">
              Recently Added/Modified
            </div>
            <div className="clearing-partner-records">
              {advisorRepresentativePlans?.length ?? 0} Records found
            </div>
          </div>
        </div>
        <div className="clearing-partner-table">
          <div className="header-clearing-partner">
            <div className="table-header-clearing-partner">Plan Name</div>
            {/* <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" /> */}
          </div>
          <div className="header-clearing-partner">
            <div className="table-header-clearing-partner">Plan ID</div>
            {/* <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" /> */}
          </div>
        </div>
        <Table className="details-table">
          <Table.Tbody className="body-tables">
            {!isEmpty(advisorRepresentativePlans) &&
              advisorRepresentativePlans.map((e, i) => (
                <Table.Tr className="data-row">
                  <div className="table-details">{e.planName}</div>
                  <div className="table-details">{e.rkPlanNumber}</div>
                </Table.Tr>
              ))}
          </Table.Tbody>
        </Table>
      </div>
    </ManageMastersLayout>
  );
};

export default AdvisorRepresentativePlanContainer;
